// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
// pages
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import Dashboard from './pages/Dashboard';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import AccountSettingsPage from './pages/AccountSettingsPage';
import AccountCreationPage from './pages/AccountCreationPage';
import { BOSC_ID, WFH_COMPANY_IDS } from './utils/envVariables';
import { ProjectHeader } from './pages/projects/Layout';
import ReleaseNotePage from './pages/ReleaseNotePage';
import {
  Clients,
  Employees,
  // HolidayList,
  MyTask,
  ProjectBoardView,
  ProjectDetails,
  ProjectOverview,
  Projects,
  ProjectSetting,
  // QuarterGoal,
  Report,
  // SurveyResponses,
  DeveloperScorecard,
  SurveyResponses,
  Teams,
  Timeline,
  TimeTracker,
  // EmployeesTimeLine,
} from './pages';
import ProjectFiles from './pages/projects/ProjectFiles';
import LeavesPage from './pages/leaves/Leaves';
import LeaveDetails from './pages/leaves/components/LeaveDetails';
import WfhPage from './pages/wfh/Wfh';
import WfhDetails from './pages/wfh/components/WfhDetails';
import CompOffPage from './pages/compOff/CompOff';
import { CompOffDetails } from './pages/compOff/components';
import ReimbursementsPage from './pages/reimbursements/Reimbursements';
import { ReimbursementDetails } from './pages/reimbursements/components';
import EscalationsPage from './pages/escalations/Escalations';
import EscalationDetail from './pages/escalations/components/EscalationDetail';
import EscalationAnalytics from './pages/escalations/components/EscalationAnalytics';
import MyTaskBoardPage from './pages/mytask/MyTaskBoardPage';
import TaskDetail from './pages/mytask/components/TaskDetail';
import HolidayListPage from './pages/holiday/HolidayListPage';
import { QuarterGoalPage } from './pages/quarterGoal/QuarterGoalPage';

import ProfilePage from './pages/ProfilePage';
import Assets from './pages/assets/Assets';
import ProjectSummaryDashboard from './pages/projects/ProjectSummaryDashboard';

// ----------------------------------------------------------------------

export const routesData = [
  {
    path: '/',
    layout: DashboardLayout,
    routes: [
      { path: 'app', component: Dashboard, permission: 'CONTENT_DASHBOARD' },
      { path: '/', component: Dashboard, permission: 'CONTENT_DASHBOARD' },
      { path: 'timetracker', component: TimeTracker, permission: 'RUN_TIMETRACKER' },
      { path: 'report', component: Report, permission: 'CREATE_REPORT' },
      { path: 'dashboard', component: Dashboard, permission: 'CONTENT_DASHBOARD' },
      { path: 'timeline', component: Timeline, permission: 'RUN_TIMETRACKER' },
      { path: 'timeline/:id', component: Timeline, permission: 'EDIT_TIMELINE' },
      { path: 'account', component: AccountSettingsPage, permission: 'READ_ACCOUNT' },
      // { path: 'holiday', component: HolidayList, companyId: BOSC_ID },
      // { path: 'weeklygoal', component: WeeklyGoalPage, companyId: BOSC_ID },
      // { path: 'quartergoal', component: QuarterGoal, companyId: BOSC_ID },
      { path: 'project/:id/settings', component: ProjectSetting, permission: 'READ_PROJECT' },
      // { path: 'projects/:status', component: Projects, permission: 'READ_PROJECT' },
      { path: 'projects', component: Projects, permission: 'READ_PROJECT' },
      { path: 'project-dashboard', component: ProjectSummaryDashboard, permission: 'READ_PROJECT' },
      {
        path: 'project/',
        layout: ProjectHeader,
        permission: 'READ_PROJECT',
        routes: [
          { path: 'overview/:id', component: ProjectOverview, permission: 'READ_PROJECT' },
          { path: 'details/:id', component: ProjectDetails, permission: 'READ_PROJECT' },
          { path: 'board/:id', component: ProjectBoardView, permission: 'READ_PROJECT' },
          { path: 'files/:id', component: ProjectFiles, permission: 'READ_PROJECT' },
        ],
      },
      { path: 'mytask', redirect: 'board', permission: 'READ_TASK' },
      { path: 'mytask/table', component: MyTask, permission: 'READ_TASK' },
      { path: 'mytask/:id', component: TaskDetail, permission: 'READ_TASK' },
      { path: 'mytask/board', component: MyTaskBoardPage, permission: 'READ_TASK' },
      { path: 'clients', component: Clients, permission: 'CREATE_CLIENT' },
      { path: 'users', component: Employees, permission: 'READ_USER' },
      // { path: 'admin/employees-timeline', component: EmployeesTimeLine, permission: 'READ_USER' },
      // { path: 'admin/survey-responses', component: SurveyResponses, permission: 'READ_USER' },
      { path: 'admin/developer-scorecard', component: DeveloperScorecard, permission: 'READ_USER', companyId: BOSC_ID },
      // { path: 'admin/projects-timeline', component: EmployeesTimeLine, permission: 'READ_USER' },
      { path: 'team', component: Teams, permission: 'CREATE_TEAM' },
      { path: 'leaves', component: LeavesPage, permission: 'READ_LEAVE' },
      { path: 'leaves/:id', component: LeaveDetails, permission: 'READ_LEAVE' },
      { path: 'wfh', component: WfhPage, permission: 'READ_WFH', companyIds: WFH_COMPANY_IDS },
      { path: 'wfh/:id', component: WfhDetails, permission: 'READ_WFH', companyIds: WFH_COMPANY_IDS },
      { path: 'comp-off', component: CompOffPage, permission: 'READ_COMP_OFF', companyId: BOSC_ID },
      { path: 'comp-off/:id', component: CompOffDetails, permission: 'READ_COMP_OFF', companyId: BOSC_ID },
      { path: 'reimbursements', component: ReimbursementsPage, permission: 'READ_REIMBURSEMENT', companyId: BOSC_ID },
      { path: 'reimbursements/:id', component: ReimbursementDetails, permission: 'READ_REIMBURSEMENT', companyId: BOSC_ID },
      { path: 'escalations', component: EscalationsPage, permission: 'READ_ESCALATION' },
      { path: 'escalations/analytics', component: EscalationAnalytics, permission: 'READ_ESCALATION' },
      { path: 'escalations/:id', component: EscalationDetail, permission: 'READ_ESCALATION' },
      { path: 'release-notes', component: ReleaseNotePage },
      { path: 'organization/quartergoal', component: QuarterGoalPage },
      { path: 'organization/holiday', component: HolidayListPage },
      { path: 'profile', component: ProfilePage, permission: 'READ_USER' },
      { path: 'employee/profile/:userId', component: ProfilePage, permission: 'READ_USER' },
      { path: 'assets', component: Assets, permission: 'READ_USER' },
      { path: '*', component: Page404 },
      { path: 'auth/changepassword', component: ChangePasswordPage },
    ],
    isProtected: true,
  },
  {
    path: '/auth',
    layout: SimpleLayout,
    routes: [
      { path: 'login', component: LoginPage },
      { path: 'login/:token', component: LoginPage },
      { path: 'createaccount', component: AccountCreationPage },
      { path: 'forgotpassword', component: ForgotPasswordPage },
      { path: 'resetpassword/:token', component: ResetPasswordPage },
      { path: '*', component: Page404 },
    ],
  },
  {
    layout: SimpleLayout,
    routes: [
      { path: '404', component: Page404 },
      { path: '*', component: Page404 },
    ],
  },
];
